module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-lounge-960-eec62d04.jpg";